import { useMutation } from '@tanstack/react-query';

import { apiRequest } from '../api/client';
import { useSessionStore } from './session-store';

/**
 * The refresh cookie is cleared server side regardless of what is presented,
 * so this never needs to name it — same reasoning as `useRestoreSession`.
 */
export function useLogout() {
  const clear = useSessionStore((state) => state.clear);

  return useMutation({
    mutationFn: () =>
      apiRequest<void>('/auth/logout', { method: 'POST', body: JSON.stringify({}) }),
    onSuccess: () => {
      clear();
    },
  });
}
